import React from 'react';
import styles from './Toast.module.scss';
import xMark from '../../assets/x-mark.svg';

const Toast = ({ message, closeToast }) => {
  return (
    <div className={`${styles.toast}`} tabIndex={0}>
      {message}
      <div onClick={closeToast}>
        <img className={`${styles.close}`} src={xMark} alt="x-mark" />
      </div>
    </div>
  );
};

export default Toast;
